import axios from "axios";
import React, { useState } from "react";

const useSearchListPagination = () => {
    const [allData, setallData] = useState([]);
    const [isKeyPress, setisKeyPress] = useState(false);
    const [Count, setCount] = useState();
    const [searchKey, setsearchKey] = useState("");
    const [record, setRecord] = useState(5);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [pages, setPages] = useState(1);
    const [pageNumberlimit, setPageNumberlimit] = useState(1);
    const [maxPageNumberlimit, setMaxPageNumberlimit] = useState(4);
    const [minPageNumberlimit, setMinPageNumberlimit] = useState(0);
    const [totallength, setTotallength] = useState([]);
    const [responseData, setresponseData] = useState({});
    const [paginationLoading, setLoadingPagination] = useState();


    const PagesFunc = (val) => {
        setisKeyPress(true);
        setPages(val);
    };
    function handleNextbtn() {
        setisKeyPress(true);
        setPages(pages + 1);
        if (pages + 1 > maxPageNumberlimit) {
            setMaxPageNumberlimit(maxPageNumberlimit + pageNumberlimit);
            setMinPageNumberlimit(minPageNumberlimit + pageNumberlimit);
        }
    }

    function handlePrevbtn() {
        setisKeyPress(true);
        setPages(pages - 1);
        if ((pages - 1) % pageNumberlimit == 0) {
            setMaxPageNumberlimit(maxPageNumberlimit - pageNumberlimit);
            setMinPageNumberlimit(minPageNumberlimit - pageNumberlimit);
        }
    }

    const PageShowFunc = totallength?.map((items, i) => {
      
        if (items) {
            return (
                <li key={i}>
                    <button
                        value={items}
                        name="pages"
                        className={pages == items ? "active" : null}
                        onClick={(e) => PagesFunc(items)}
                    >
                        {items}
                    </button>
                </li>
            );
        } else {
            return null;
        }
    });
    const SearchListApi = async (serachitem,profileId={}, source) => {

        setLoadingPagination(true);
        if (!isKeyPress) {
            setPages(1);
        }
        await axios
            .post(`${serachitem}/list`, {
                search: searchKey,
                record: parseInt(record) ,
                page: isKeyPress ? pages : 1,
                [Object.keys(profileId)[0]]:Object.values(profileId)[0]
            })
            .then((res) => {

                setresponseData(res?.data)
                if (res?.data) {
                    const removeNull = res?.data?.result?.rows?.map(item => {
                        return Object.keys(item).forEach(function (key) {
                            if (item[key] === null) {
                                item[key] = '';
                            }
                        })
                    })


                    setallData(res?.data?.result?.rows);
                }
                setCount(res?.data?.result?.count);

                let pageNo = res.data?.result?.totallength;
                let pagelist = [];

                for (let i = 0; i < pageNo; i++) {
                    pagelist.push(i + 1);
                }
                setTotallength(pagelist);

            })
            .finally(() => setLoadingPagination(false));
    };
    const callAnyApi = async (serachitem, source) => {

        setLoadingPagination(true);
        if (!isKeyPress) {
            setPages(1);
        }
        await axios
            .post(`${serachitem}`, {
                search: searchKey,
                record: parseInt(record) ,
                page: isKeyPress ? pages : 1,
                month:month,
                year:year
            
            })
            .then((res) => {

                setresponseData(res?.data)
                if (res?.data) {
                    const removeNull = res?.data?.result?.rows?.map(item => {
                        return Object.keys(item).forEach(function (key) {
                            if (item[key] === null) {
                                item[key] = '';
                            }
                        })
                    })


                    setallData(res?.data?.result?.rows);
                }
                setCount(res?.data?.result?.count);

                let pageNo = res.data?.result?.totallength;
                let pagelist = [];

                for (let i = 0; i < pageNo; i++) {
                    pagelist.push(i + 1);
                }
                setTotallength(pagelist);

            })
            .finally(() => setLoadingPagination(false));
    };




    return {
        isKeyPress,
        setisKeyPress,
        Count,
        setCount,
        setsearchKey,
        searchKey,
        setRecord,
        record,
        setPages,
        pages,
        pageNumberlimit,
        setPageNumberlimit,
        minPageNumberlimit,
        setMinPageNumberlimit,
        totallength,
        setTotallength,
        paginationLoading,
        setLoadingPagination,
        handleNextbtn,
        handlePrevbtn,
        PageShowFunc,
        SearchListApi,
        allData,
        responseData ,
        callAnyApi ,
        PagesFunc,
        setYear,
        year,
        month, setMonth

    };
};

export default useSearchListPagination;
